import { Box, Button, Stack } from '@mui/material';

interface KeyboardProps {
  keyboard: Array<Array<{ text: string; callback_data: string }>>;
  onButtonClick: (messageId: string, callbackData: string) => void;
  messageId: string;
}

export function Keyboard({ keyboard, onButtonClick, messageId }: KeyboardProps) {
  return (
    <Stack mb={1.5}>
      {keyboard.map((row, rowIdx) => (
        <Box key={row.map((button) => button.text).join('-') + rowIdx} mb={1} display="flex" gap={1}>
          {row.map((button, btnIdx) => (
            <Button
              key={button.text + btnIdx}
              variant="contained"
              fullWidth
              sx={{
                display: 'inline-flex',
                minWidth: 0,
                px: 1,
              }}
              onClick={() => onButtonClick(messageId, button.callback_data)}
            >
              <span
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
                title={button.text}
              >
                {button.text}
              </span>
            </Button>
          ))}
        </Box>
      ))}
    </Stack>
  );
}
